<template>
  <button
    :type="buttonType"
    class="max-h-[3.125rem] h-[3.125rem] rounded-xl"
    :class="[{ 'btn-primary': type === 'default' }, buttonClass]"
    :disabled="disabled"
  >
    <div
      class="text-base font-medium flex items-center justify-center"
      :class="[buttonTextClass, type === 'link' ? 'btn-primary-link' : '']"
    >
      <slot name="prefix" />
      {{ buttonText }}
      <slot name="postfix" />
    </div>
  </button>
</template>

<script lang="ts" setup>
  interface IProps {
    buttonTextClass?: string;
    disabled?: boolean;
    type?: "default" | "link";
    buttonText: string;
    buttonClass?: string;
    buttonType?: "button" | "submit";
  }

  withDefaults(defineProps<IProps>(), {
    type: "default",
    buttonType: "button",
  });
</script>

<style></style>
